/**
 * Returns default FAQ items for stores that don't have custom FAQ
 * content in h3+p format yet. Used as fallback when parseFaqFromHtml
 * returns an empty array.
 *
 * @param {string} storeName - Store display name
 * @returns {Array<{ question: string, answer: string }>}
 */
export default function getDefaultFaq(storeName) {
  return [
    {
      question: `Como usar cupons ${storeName}?`,
      answer: `Escolha o cupom desejado, clique em "Ir à loja" e o código será copiado automaticamente. Cole no carrinho de compras da ${storeName} para aplicar o desconto.`,
    },
    {
      question: `Os cupons ${storeName} são verificados?`,
      answer:
        'Sim, os cupons são verificados pela comunidade do Promobit e atualizados diariamente.',
    },
    {
      question: `Posso usar mais de um cupom ${storeName}?`,
      answer:
        'Geralmente cada compra aceita apenas um cupom de desconto. Verifique as regras de cada cupom antes de aplicar.',
    },
    {
      question: `Os cupons ${storeName} expiram?`,
      answer: `Sim, cada cupom ${storeName} possui uma data de validade. Verifique sempre as condições e o prazo de uso antes de aplicar o cupom na sua compra.`,
    },
  ];
}
